import React from 'react';

const Header = () => {
  return (
    <header
      id="site-header"
      style={{
        padding: '20px 5%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: 'white',
        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        transform: 'translateY(-100%)',
        transition: 'transform 0.3s ease-in-out'
      }}
    >
      <div style={{ 
        fontSize: '24px', 
        fontWeight: 700, 
        color: '#1a73e8',
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
        <div style={{
          width: '30px',
          height: '30px',
          backgroundColor: '#1a73e8',
          borderRadius: '50%'
        }}></div>
        <div style={{
          display: 'flex',
          alignItems: 'baseline',
          gap: '18px'
        }}>
          <span>watt</span>
          <span style={{
            fontSize: '14px',
            fontWeight: 400,
            fontStyle: 'bold',
            color: '#666'
          }}>
            Energy Insights. Peer Reviewed
          </span>
        </div>
      </div>
      <nav>
        <ul style={{ 
          display: 'flex', 
          listStyle: 'none', 
          gap: '30px', 
          margin: 0,
          padding: 0
        }}>
          <li><a href="#top" style={{ color: '#333', textDecoration: 'none' }}>Home</a></li>
          <li><a href="#services" style={{ color: '#333', textDecoration: 'none' }}>Services</a></li>
          <li><a href="#expertise" style={{ color: '#333', textDecoration: 'none' }}>Expertise</a></li>
          <li><a href="#regions" style={{ color: '#333', textDecoration: 'none' }}>Regions</a></li>
          <li><a href="#about" style={{ color: '#333', textDecoration: 'none' }}>About</a></li>
          <li><a href="#contact" style={{ color: '#fff', textDecoration: 'none', backgroundColor: '#1a73e8', padding: '8px 15px', borderRadius: '4px' }}>Contact</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;